// 根据关键字搜索

import React, { Component } from 'react';
import { Button, Form, Input } from 'antd';
import { connect } from 'react-redux';
import { queryExportIncCustomList } from '@api/incubator/custom';

const FormItem = Form.Item;

class ConditionSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    // 切换孵化器时，条件置空
    if (nextProps.params.uuid !== this.props.condition.incubatorUuid) {
      this.resetFields();
    }
  }

  onSearch = () => {
    const value = this.props.form.getFieldsValue();
    const { fieldName } = this.props;
    const params = {};
    params[fieldName] = value[fieldName] || '';
    this.props.onChange(params);
  };

  resetFields = () => {
    this.props.form.resetFields();
  };

  onReset = () => {
    const { fieldName } = this.props;
    const params = {};
    params[fieldName] = '';
    this.props.onChange(params);
    this.props.form.resetFields();
  };

  export = () => {
    const { tab } = this.props;
    this.setState({ exportLoading: true });
    queryExportIncCustomList({
      tab: tab === 2 ? 'incubatingCustomer' : 'residentCustomer',
      condition: this.props.condition.condition,
    }).then(() => {
      this.setState({ exportLoading: false });
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      fieldName,
      initialValue,
    } = this.props;
    return (
      <Form style={{ textAlign: 'right' }} layout="inline">
        <FormItem>
          {getFieldDecorator(fieldName, {
            initialValue,
          })(<Input style={{ marginLeft: '8px' }} placeholder="请输入关键字" />)}
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            style={{ marginLeft: '8px' }}
            onClick={this.onSearch}
            loading={this.props.loading}
          >
            搜索
          </Button>
          <Button style={{ marginLeft: '8px' }} onClick={this.onReset}>
            重置
          </Button>

          {this.props.export && (
            <Button
              icon="export"
              style={{ marginLeft: '8px', marginRight: '-16px' }}
              onClick={this.export}
              loading={this.state.exportLoading}
            >
              导出
            </Button>
          )}
        </FormItem>
      </Form>
    );
  }
}

export default connect(state => ({
  tab: state.incu_custom_list.tab,
  condition: state.incu_custom_list.condition,
}))(Form.create({ wrappedComponentRef: true })(ConditionSearch));



// WEBPACK FOOTER //
// ./src/components/comm/search/ConditionSearch.js